module.exports = __webpack_public_path__ + "img/downloadicon.efcb668e.svg";